<template>
  <el-dropdown>
  <span class="el-dropdown-link">
    {{$t('feed.actions.title')}}<i class="el-icon-arrow-down el-icon--right"></i>
  </span>
    <el-dropdown-menu>
      <el-dropdown-item>
          <router-link
            :to="{ name: 'feedSettings', params: { threadId: threadId }}"
            class="action-feed__link"
          >
          <i class="el-icon-s-tools"></i> {{$t('feed.actions.items[0]')}}
        </router-link>
      </el-dropdown-item>
      <el-dropdown-item v-if="status === 'pause'" @click.native="toggleLaunch">
        <i class="el-icon-video-play"></i> {{$t('feed.actions.items[1]')}}
      </el-dropdown-item>
      <el-dropdown-item v-else @click.native="toggleLaunch">
        <i class="el-icon-video-pause" ></i> {{$t('feed.actions.items[2]')}}
      </el-dropdown-item>
      <el-dropdown-item divided @click.native="deleteFeed">
        <i class="el-icon-delete-solid"></i> {{$t('feed.actions.items[3]')}}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  export default {
    name: 'FeedActions',
    props: ['threadId', 'feedName', 'status'],
    methods: {
      deleteFeed() {
        this.$alert(`Удалить ленту ${this.feedName}?`, 'Удаление', {
          confirmButtonText: 'ДА',
          cancelButtonText: 'НЕТ',
          showCancelButton: true,
          callback: action => {
            if (action === 'confirm') {
              this.$emit('handleFeedDelete', this.threadId);
            } else {
              this.$message({
                type: 'info',
                message: `удаление отменено`
              });
            }
          }
        });
      },
      toggleLaunch() {
        this.$emit('toggleLaunch', {threadId: this.threadId, status: this.status});
      },
    },
  };
</script>

<style>
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }

  .action-feed__link,
  .action-feed__link:visited {
    display: inline-block;
    margin-bottom: 10px;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 16px;
    color: #000000;
    text-decoration: none;
  }

  .action-feed__link:hover,
  .action-feed__link:focus,
  .action-feed__link:active {
    color: #1989fa;
  }
</style>
